import { render, staticRenderFns } from "./PressJoinSettings.vue?vue&type=template&id=14e66281"
import script from "./PressJoinSettings.vue?vue&type=script&lang=ts"
export * from "./PressJoinSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports